import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-963752da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "json-editor" }
const _hoisted_2 = {
  key: 0,
  class: "toggle-button-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-copy" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Copy", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-paste" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Paste", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmingButton = _resolveComponent("ConfirmingButton")!
  const _component_MonacoWrapper = _resolveComponent("MonacoWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.copyable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ConfirmingButton, {
            "onUpdate:callback": _cache[0] || (_cache[0] = ($event: any) => (_ctx.copy()))
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_ConfirmingButton, {
            "onUpdate:callback": _cache[1] || (_cache[1] = ($event: any) => (_ctx.paste()))
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_MonacoWrapper, {
      modelValue: _ctx.jsonString,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.jsonString = $event)),
      class: "editor",
      language: "json",
      ref: "monacoWrapperComponent",
      adjustToContent: true,
      onInitialize: _cache[3] || (_cache[3] = ($event: any) => (_ctx.initializeEditor($event)))
    }, null, 8, ["modelValue"])
  ]))
}